// removed by extract-text-webpack-plugin
module.exports = {"root":"extra-data--root--3amYiK0L","card-header":"extra-data--card-header--1vDpdoMb order-card--header--1yBG70qV","cardHeader":"extra-data--card-header--1vDpdoMb order-card--header--1yBG70qV","card-body":"extra-data--card-body--9MLA_-ok order-card--body--N03E2PVP","cardBody":"extra-data--card-body--9MLA_-ok order-card--body--N03E2PVP","card-body-refund":"extra-data--card-body-refund--2QDrcvKK","cardBodyRefund":"extra-data--card-body-refund--2QDrcvKK"};


//////////////////
// WEBPACK FOOTER
// ./views/order-detail/extra-data/styles.css
// module id = ./views/order-detail/extra-data/styles.css
// module chunks = 0